import React from 'react';
import { Edit, SimpleForm, TextInput } from 'react-admin';
import { Breadcrumbs, Container, Link as MuiLink, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router';
import AppBarSaveActions from '../components/AppBarSaveActions.tsx';

const IndustryEdit: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Breadcrumbs sx={{ mt: 2 }}>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/">
          Dashboard
        </MuiLink>
        <MuiLink component={RouterLink} underline="hover" color="inherit" to="/industry">
          Industries
        </MuiLink>
        <Typography color="text.primary">Manage</Typography>
      </Breadcrumbs>
      <Edit mutationMode="pessimistic">
        <SimpleForm toolbar={<AppBarSaveActions />}>
          <Container maxWidth="md">
            <Typography variant="h6" gutterBottom>
              Industry
            </Typography>
            <TextInput source="name" helperText={false} fullWidth />
          </Container>
        </SimpleForm>
      </Edit>
    </Container>
  );
};

export default IndustryEdit;
